import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ReactLink from '@client/components/reactLink/ReactLink';
import styles from '@client/containers/sideBarMenu/menuDrawerItem/menuDrawerItem.scss';
import styleHelper from '@client/shared/styles/styleHelper.scss';
import ArrowSvg from '@client/components/icons/arrowSvg/ArrowSvg';

function hasSubRoutesButAllAreRestricted(subRoutesOrUndefined) {
  // An empty subroute object means that all subroutes are restricted
  return (
    subRoutesOrUndefined && Object.entries(subRoutesOrUndefined).length === 0
  );
}

const MenuDrawerItem = ({
  route,
  index,
  alwaysShowSubRoutes,
  containerClassName,
  linkClassName,
  subLinkClassName,
  handleClick = () => null,
}) => {
  const subRoutesOrUndefined = route.ROUTES;

  if (hasSubRoutesButAllAreRestricted(subRoutesOrUndefined)) {
    return null;
  }

  const [showSubRoutes, setShowSubRoutes] = useState(alwaysShowSubRoutes);

  const toggleShowSubRoutes = () => {
    if (!alwaysShowSubRoutes) {
      setShowSubRoutes(!showSubRoutes);
    }
  };

  return (
    <div
      className={`${styles.menuDrawerItem} ${
        containerClassName ? containerClassName : ''
      }`}
      key={`DrawerItem${index}:${route.TO}`}
    >
      {subRoutesOrUndefined ? (
        <button
          className={`${styles.link} ${linkClassName ? linkClassName : ''} ${
            alwaysShowSubRoutes ? styles.inactive : ''
          }`}
          onClick={toggleShowSubRoutes}
        >
          {route.LABEL}
          {!alwaysShowSubRoutes && (
            <ArrowSvg className={styles.icon} onToggle={showSubRoutes} />
          )}
        </button>
      ) : (
        <ReactLink
          exact
          to={route.TO}
          handleClick={handleClick}
          activeClassName={styles.active}
          className={`${styles.link} ${linkClassName ? linkClassName : ''}`}
        >
          {route.LABEL}
        </ReactLink>
      )}
      {subRoutesOrUndefined && (
        <div
          className={`${styleHelper.flexCol} ${
            showSubRoutes ? styles.show : styles.hide
          }`}
        >
          {subRoutesOrUndefined &&
            Object.values(subRoutesOrUndefined).map((subRoute, index) => {
              return (
                <ReactLink
                  exact
                  key={`subLink${index}:${subRoute.TO}`}
                  to={subRoute.TO}
                  handleClick={handleClick}
                  activeClassName={styles.active}
                  className={`${styles.subLink} ${
                    subLinkClassName ? subLinkClassName : ''
                  }`}
                >
                  {subRoute.LABEL}
                </ReactLink>
              );
            })}
        </div>
      )}
    </div>
  );
};

MenuDrawerItem.propTypes = {
  route: PropTypes.object,
  handleClick: PropTypes.func,
};
export default MenuDrawerItem;
